import { $api } from "@/services/api";
import store from "@/store";
const state = {
  totalReceipt: {
    all: 0,
    inProcess: 0,
    waitingForCancelApproved: 0,
  },
  evaluationForm: {
    comment: "",
    questionnaireScore: [],
  },
  receiptForm: {
    poId: "",
    budgetYear: "",
    sapPoNumber: "",
    prNumber: "",
    project: "",
    subject: "",
    vendor: "",
    deliveryNote: "",
    receiptDate: "",
    invoiceNumber: "",
    invoiceDate: "",
    note: "",
    deliveryType: "",
  },
  receiptItems: [],
  receiptFiles: [],
  isSelectAllItems: "",
  poReceiptDocumentStatus: "",
  poReceiptStatus: "",
  poReceiptNumber: "",
};

const getters = {
  receiptForm: (state) => state.receiptForm,
  receiptItems: (state) => state.receiptItems,
  receiptFiles: (state) => state.receiptFiles,
  totalReceipt: (state) => state.totalReceipt,
  evaluationForm: (state) => state.evaluationForm,
  isSelectAllItems: (state) => state.isSelectAllItems,
  poReceiptDocumentStatus: (state) => state.poReceiptDocumentStatus,
  poReceiptStatus: (state) => state.poReceiptStatus,
  poReceiptNumber: (state) => state.poReceiptNumber,
};

const mutations = {
  async setAllReceipt(state, total) {
    state.totalReceipt.all = total;
  },
  async setInProcessReceipt(state, total) {
    state.totalReceipt.inProcess = total;
  },
  async setWaitingForCancelApprovedReceipt(state, total) {
    state.totalReceipt.waitingForCancelApproved = total;
  },
  setEvaluationForm(state, obj) {
    state.evaluationForm.comment = obj.comment;
    state.evaluationForm.questionnaireScore = obj.questionnaireScore;
  },
  setReceiptForm(state, obj) {
    state.receiptForm.poId = obj.poId;
    state.receiptForm.budgetYear = obj.budgetYear;
    state.receiptForm.sapPoNumber = obj.sapPoNumber;
    state.receiptForm.prNumber = obj.prNumber;
    state.receiptForm.project = obj.project;
    state.receiptForm.subject = obj.subject;
    state.receiptForm.vendor = obj.vendor;
    state.receiptForm.deliveryNote = obj.deliveryNote;
    state.receiptForm.receiptDate = obj.receiptDate;
    state.receiptForm.invoiceNumber = obj.invoiceNumber;
    state.receiptForm.invoiceDate = obj.invoiceDate;
    state.receiptForm.note = obj.note;
    state.receiptForm.deliveryType = obj.deliveryType;
  },
  setReceiptItems(state, items) {
    state.receiptItems = items;
  },
  setReceiptFiles(state, files) {
    state.receiptFiles = files;
  },
  setIsSelectAllItems(state, bool) {
    state.isSelectAllItems = bool;
  },
  clearReceiptForm(state) {
    state.receiptForm.poId = "";
    state.receiptForm.budgetYear = "";
    state.receiptForm.sapPoNumber = "";
    state.receiptForm.prNumber = "";
    state.receiptForm.project = "";
    state.receiptForm.subject = "";
    state.receiptForm.vendor = "";
    state.receiptForm.deliveryNote = "";
    state.receiptForm.receiptDate = "";
    state.receiptForm.invoiceNumber = "";
    state.receiptForm.invoiceDate = "";
    state.receiptForm.note = "";
    state.receiptForm.deliveryType = "";
  },
  clearReceiptItems(state) {
    state.receiptItems = [];
  },
  clearReceiptFiles(state) {
    state.receiptFiles = [];
  },
  clearEvaluationFormState(state) {
    state.evaluationForm = {
      comment: "",
      questionnaireScore: [],
    };
  },
  clearIsSelectAllItems(state) {
    state.isSelectAllItems = "";
  },
  async updatePoReceiptDocumentStatus(state, status) {
    state.poReceiptDocumentStatus = status;
  },
  async updatePoReceiptStatus(state, status) {
    state.poReceiptStatus = status;
  },
  async updatePoReceiptNumber(state, RCNumber) {
    state.poReceiptNumber = RCNumber;
  },
};

const actions = {
  async getTotalReceipt({ commit }) {
    const baseQuery = store.getters.isSpecialUser
      ? `?vendor_status[$in][0]=Waiting for Receipt&vendor_status[$in][1]=Waiting for Delivery Confirmation&is_delivery_completed=false&is_active=true`
      : `?vendor_status[$in][0]=Waiting for Receipt&vendor_status[$in][1]=Waiting for Delivery Confirmation&is_delivery_completed=false&requested_by_user=${store.getters.user.userName}&is_active=true`;

    const response = await $api.v_pos.getPosWithQueryString(
      `${baseQuery}&$skip=0&$limit=5000`
    );
    const rows = response?.data || [];
    const normalizeCancelStatus = (status) => {
      if (status === null || status === undefined) return "null";
      const text = status.toString().trim().toLowerCase();
      return text || "null";
    };

    const inProcessTotal = rows.filter((row) => {
      const status = normalizeCancelStatus(row.cancel_status);
      return status === "null" || status === "rejected";
    }).length;

    const waitingForCancelApprovedTotal = rows.filter((row) => {
      const status = normalizeCancelStatus(row.cancel_status);
      return (
        status === "waiting for approval" ||
        status === "waiting for procurement approval"
      );
    }).length;

    commit("setInProcessReceipt", inProcessTotal);
    commit(
      "setWaitingForCancelApprovedReceipt",
      waitingForCancelApprovedTotal
    );
    commit(
      "setAllReceipt",
      inProcessTotal + waitingForCancelApprovedTotal
    );
  },
  setEvaluationForm({ commit }, obj) {
    commit("setEvaluationForm", obj);
  },
  setReceiptForm({ commit }, obj) {
    commit("setReceiptForm", obj);
  },
  setReceiptItems({ commit }, items) {
    commit("setReceiptItems", items);
  },
  setReceiptFiles({ commit }, files) {
    commit("setReceiptFiles", files);
  },
  setIsSelectAllItems({ commit }, bool) {
    commit("setIsSelectAllItems", bool);
  },
  clearReceiptForm({ commit }) {
    commit("clearReceiptForm");
  },
  clearReceiptItems({ commit }) {
    commit("clearReceiptItems");
  },
  clearReceiptFiles({ commit }) {
    commit("clearReceiptFiles");
  },
  clearEvaluationFormState({ commit }) {
    commit("clearEvaluationFormState");
  },
  clearIsSelectAllItems({ commit }) {
    commit("clearIsSelectAllItems");
  },
  async updatePoReceiptDocumentStatus({ commit }, status) {
    commit("updatePoReceiptDocumentStatus", status);
  },
  async clearPoReceiptDocumentStatus({ commit }) {
    commit("updatePoReceiptDocumentStatus", "");
  },
  async updatePoReceiptStatus({ commit }, status) {
    commit("updatePoReceiptStatus", status);
  },
  async clearPoReceiptStatus({ commit }) {
    commit("updatePoReceiptStatus", "");
  },
  async updatePoReceiptNumber({ commit }, RCNumber) {
    commit("updatePoReceiptNumber", RCNumber);
  },
  async clearPoReceiptNumber({ commit }) {
    commit("updatePoReceiptNumber", "");
  },
};

export default { state, getters, mutations, actions };
